/**
 * Hook chamado UMA vez pelo app-core (`ui/modules.tsx`): a camada do município
 * da busca e da localização no mapa.
 */
import { useEffect } from 'react';
import { useMapInstance } from '../map/mapContext';
import { BuscaLayer } from './layer';

export function useBuscaLayer(): void {
  const map = useMapInstance((s) => s.map);
  useEffect(() => {
    if (!map) return;
    const camada = new BuscaLayer(map);
    return () => camada.dispose();
  }, [map]);
}
